import React from 'react';
import AddModalFormWrapper from './AddModalFormWrapper';
import EditFormWrapper from './EditFormWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function FormWrapper(_ref) {
  var assetContentType = _ref.assetContentType,
    isEditMode = _ref.isEditMode,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    children = _ref.children,
    isSaving = _ref.isSaving,
    isSubmitDisabled = _ref.isSubmitDisabled,
    inContentManagerContext = _ref.inContentManagerContext,
    hasChanges = _ref.hasChanges,
    onSubmit = _ref.onSubmit,
    onDiscard = _ref.onDiscard,
    onClose = _ref.onClose;
  if (isEditMode && onDiscard) {
    return /*#__PURE__*/_jsx(EditFormWrapper, {
      isSaving: isSaving,
      isSubmitDisabled: isSubmitDisabled,
      inContentManagerContext: inContentManagerContext,
      hasChanges: hasChanges,
      onSubmit: onSubmit,
      onDiscard: onDiscard,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(AddModalFormWrapper, {
    assetContentType: assetContentType,
    onClose: onClose,
    inContentManagerContext: inContentManagerContext,
    isLoading: isLoading,
    isError: isError,
    isSaving: isSaving,
    isSubmitDisabled: isSubmitDisabled,
    onSubmit: onSubmit,
    children: children
  });
}
export default FormWrapper;